import { MIN_SESSION_INACTIVITY_MINUTES, MAX_SESSION_INACTIVITY_MINUTES } from "../../src/domain/settingsBounds.ts";
import { boundRangeText } from "./session.ts";
import { ADMIN_SECTION_ORDER } from "./settingsGate.ts";

// Shared Settings chrome. Controllers retain the existing panel nodes and behavior.
const HEADER = `<div class="tabs-page-header" id="admin-settings-header" data-testid="admin-settings-header">
            <h1 class="tabs-page-title">Settings</h1>
          </div>`;
const RAIL = `<aside class="settings-rail" data-testid="admin-settings-rail">
              <div class="settings-search-wrap">
                <input
                  class="settings-search-input"
                  type="search"
                  id="admin-settings-search"
                  data-testid="admin-settings-search"
                  placeholder="Search settings"
                  aria-label="Search settings"
                  autocomplete="off"
                />
                <p
                  class="settings-search-count"
                  id="admin-settings-search-count"
                  data-testid="admin-settings-search-count"
                  aria-live="polite"
                ></p>
              </div>
              <div
                class="settings-rail-groups"
                id="admin-settings-rail-groups"
                data-testid="admin-settings-rail-groups"
                role="tablist"
                aria-label="Settings groups"
              >
                <button
                  class="settings-rail-item"
                  type="button"
                  id="admin-group-tab-money"
                  data-testid="admin-group-tab-money"
                  role="tab"
                  aria-selected="true"
                  aria-controls="admin-group-panel-money"
                >
                  <svg class="so-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2.5" y="6" width="19" height="12" rx="2" /><circle cx="12" cy="12" r="2.8" /><path d="M6 12h.01M18 12h.01" /></svg>
                  Money and pricing
                </button>
                <button
                  class="settings-rail-item"
                  type="button"
                  id="admin-group-tab-tabspayment"
                  data-testid="admin-group-tab-tabspayment"
                  role="tab"
                  aria-selected="false"
                  aria-controls="admin-group-panel-tabspayment"
                >
                  <svg class="so-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h12v18l-3-2-3 2-3-2-3 2z" /><path d="M9 8h6M9 12h6" /></svg>
                  Tabs and payment
                </button>
                <button
                  class="settings-rail-item"
                  type="button"
                  id="admin-group-tab-recipes"
                  data-testid="admin-group-tab-recipes"
                  role="tab"
                  aria-selected="false"
                  aria-controls="admin-drinks-panel"
                >
                  <svg class="so-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 3h6M10 3v6l-5.5 9.5A1.5 1.5 0 0 0 5.8 21h12.4a1.5 1.5 0 0 0 1.3-2.5L14 9V3" /><path d="M7.5 15h9" /></svg>
                  Recipes
                </button>
                <button
                  class="settings-rail-item"
                  type="button"
                  hidden
                  id="admin-group-tab-menu"
                  data-testid="admin-group-tab-menu"
                  role="tab"
                  aria-selected="false"
                  aria-controls="admin-group-panel-menu"
                >
                  <svg class="so-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 6h13M8 12h13M8 18h13" /><path d="M3.5 6h.01M3.5 12h.01M3.5 18h.01" /></svg>
                  Menu
                </button>
                <button
                  class="settings-rail-item"
                  type="button"
                  id="admin-group-tab-inventory"
                  data-testid="admin-group-tab-inventory"
                  role="tab"
                  aria-selected="false"
                  aria-controls="admin-group-panel-inventory"
                >
                  <svg class="so-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7.5L12 3l9 4.5v9L12 21l-9-4.5z" /><path d="M3 7.5l9 4.5 9-4.5M12 12v9" /></svg>
                  Inventory items
                </button>
                <button
                  class="settings-rail-item"
                  type="button"
                  id="admin-group-tab-purchasing"
                  data-testid="admin-group-tab-purchasing"
                  role="tab"
                  aria-selected="false"
                  aria-controls="admin-group-panel-purchasing"
                >
                  <svg class="so-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6h11v10h-11zM13.5 9.5H18l3.5 3.5V16h-8" /><circle cx="7" cy="17.5" r="1.8" /><circle cx="17" cy="17.5" r="1.8" /></svg>
                  Vendors
                </button>
                <button
                  class="settings-rail-item"
                  type="button"
                  id="admin-group-tab-discounts"
                  data-testid="admin-group-tab-discounts"
                  role="tab"
                  aria-selected="false"
                  aria-controls="admin-group-panel-discounts"
                >
                  <svg class="so-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 5L5 19" /><circle cx="7" cy="7" r="2.5" /><circle cx="17" cy="17" r="2.5" /></svg>
                  Discounts
                </button>
                <button
                  class="settings-rail-item"
                  type="button"
                  id="admin-group-tab-corrections"
                  data-testid="admin-group-tab-corrections"
                  role="tab"
                  aria-selected="false"
                  aria-controls="admin-group-panel-corrections"
                >
                  <svg class="so-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 5h16v11H9l-5 4z" /><path d="M8 9.5h8M8 12.5h5" /></svg>
                  Reasons
                </button>
                <button
                  class="settings-rail-item"
                  type="button"
                  id="admin-group-tab-people"
                  data-testid="admin-group-tab-people"
                  role="tab"
                  aria-selected="false"
                  aria-controls="admin-users-panel"
                >
                  <svg class="so-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l8 3v6c0 4.5-3.2 7.8-8 9-4.8-1.2-8-4.5-8-9V6z" /></svg>
                  Team
                </button>
                <button
                  class="settings-rail-item"
                  type="button"
                  id="admin-group-tab-operations"
                  data-testid="admin-group-tab-operations"
                  role="tab"
                  aria-selected="false"
                  aria-controls="admin-group-panel-operations"
                >
                  <svg class="so-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" /></svg>
                  Location
                  <!-- CL6-F1-F3: shown while the time zone and cutoff are
                     unconfirmed, so the warning is findable from any other
                     Settings tab. Driven by ui/src/admin.ts. -->
                  <span
                    class="settings-rail-tag"
                    id="admin-group-tab-operations-tag"
                    data-testid="admin-group-tab-operations-tag"
                    hidden
                    >Needs setup</span
                  >
                </button>
                <button
                  class="settings-rail-item"
                  type="button"
                  id="admin-group-tab-tablets"
                  data-testid="admin-group-tab-tablets"
                  role="tab"
                  aria-selected="false"
                  aria-controls="admin-group-panel-tablets"
                >
                  <svg class="so-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2.5" /><path d="M11 18h2" /></svg>
                  Devices
                </button>
                <button
                  class="settings-rail-item"
                  type="button"
                  id="admin-group-tab-connections"
                  data-testid="admin-group-tab-connections"
                  role="tab"
                  aria-selected="false"
                  aria-controls="admin-group-panel-connections"
                  hidden
                >
                  <svg class="so-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 3v4M15 3v4" /><path d="M6 7h12v3a6 6 0 0 1-12 0z" /><path d="M12 16v5" /></svg>
                  Connections
                </button>
                <button
                  class="settings-rail-item"
                  type="button"
                  id="admin-group-tab-auditlog"
                  data-testid="admin-group-tab-auditlog"
                  role="tab"
                  aria-selected="false"
                  aria-controls="admin-change-history-panel"
                >
                  <svg class="so-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h9l4 4v14H6z" /><path d="M14 3v5h5M9 13h7M9 17h7" /></svg>
                  Audit log
                </button>
                <button
                  class="settings-rail-item"
                  type="button"
                  id="admin-group-tab-network"
                  data-testid="admin-group-tab-network"
                  role="tab"
                  aria-selected="false"
                  aria-controls="admin-group-panel-network"
                >
                  <svg class="so-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="5" r="2.5" /><circle cx="5" cy="19" r="2.5" /><circle cx="19" cy="19" r="2.5" /><path d="M12 7.5v4M12 11.5l-5.5 5.5M12 11.5l5.5 5.5" /></svg>
                  Billing
                </button>
              </div>
            </aside>`;

const SESSION_INACTIVITY = `<section
                    class="bd-card"
                    id="admin-session-inactivity-card"
                    data-testid="admin-session-inactivity-card"
                  >
                    <div class="bd-card-head">
                      <h3 class="bd-card-title">Session inactivity</h3>
                    </div>
                  <!-- UX22/DEC-137 slice 3: text is set from
                     ui/src/admin.ts through settingsBounds.ts's own
                     MIN_SESSION_INACTIVITY_MINUTES/
                     MAX_SESSION_INACTIVITY_MINUTES, above the field it
                     describes, so this cannot state a bound the validator
                     does not enforce. The input's own min/max attributes
                     are set from the same constants at admin.ts's module
                     load, not hardcoded here. -->
                  <label class="field-label" id="admin-settings-session-inactivity-label" for="admin-settings-session-inactivity"
                    >Timeout, in minutes</label
                  >
                  <input
                    class="field-input"
                    type="number"
                    inputmode="numeric"
                    step="1"
                    id="admin-settings-session-inactivity"
                    data-testid="admin-settings-session-inactivity"
                    aria-describedby="admin-settings-session-inactivity-help"
                    data-setting-help="limit"
                  />
                  <p
                    class="admin-field-help"
                    id="admin-settings-session-inactivity-help"
                    data-testid="admin-settings-session-inactivity-help"
                  ></p>

                    <div class="bd-actions">
                      <button
                        class="btn-secondary"
                        type="button"
                        id="admin-session-inactivity-save"
                        data-testid="admin-session-inactivity-save"
                      >
                        Save
                      </button>
                      <span
                        class="admin-settings-save-status"
                        id="admin-session-inactivity-save-status"
                        data-testid="admin-session-inactivity-save-status"
                        role="status"
                      ></span>
                    </div>
                  </section>`;

function fragment(doc: Document, markup: string): DocumentFragment {
  const template = doc.createElement("template");
  template.innerHTML = markup;
  return template.content;
}

/** Called before the live Settings controller binds any controls. */
export function mountSettingsPresentation(doc: Document): void {
  doc.getElementById("admin-session-inactivity-mount")?.replaceWith(createSessionInactivityCard(doc));
  doc.getElementById("admin-settings-header-mount")?.replaceWith(fragment(doc, HEADER));
  doc.getElementById("admin-settings-rail-mount")?.replaceWith(fragment(doc, RAIL));
}

/** Inert, identity-free sample of the exact live navigation chrome. */
export function createSettingsPreview(doc: Document): HTMLElement {
  const sample = doc.createElement("div");
  sample.className = "fr-brand-settings-sample";
  sample.inert = true;
  sample.setAttribute("aria-hidden", "true");
  sample.append(fragment(doc, HEADER), fragment(doc, RAIL));
  for (const node of sample.querySelectorAll<HTMLElement>("[id], [data-testid], [aria-controls]")) {
    for (const attribute of ["id", "data-testid", "aria-controls"]) {
      const value = node.getAttribute(attribute);
      if (value !== null) node.setAttribute(attribute, `fr-preview-${value}`);
    }
  }
  const groups = sample.querySelector("[role=tablist]")!;
  for (const section of ADMIN_SECTION_ORDER) {
    const tab = sample.querySelector<HTMLButtonElement>(
      `#fr-preview-admin-group-tab-${section.toLowerCase()}`,
    )!;
    groups.append(tab);
    tab.hidden = false;
    tab.setAttribute("aria-selected", String(section === ADMIN_SECTION_ORDER[0]));
  }
  sample.querySelector<HTMLElement>("#fr-preview-admin-group-tab-menu")!.hidden = true;
  // The preview has no live panels and is hidden from the accessibility tree.
  for (const node of sample.querySelectorAll("[aria-controls]"))
    node.removeAttribute("aria-controls");
  return sample;
}

/** Exact live field-card presentation, with controller behavior supplied by admin.ts. */
export function createSessionInactivityCard(doc: Document): HTMLElement {
  return fragment(doc, SESSION_INACTIVITY).firstElementChild as HTMLElement;
}

/** Synthetic field example only, without live Settings controllers or requests. */
export function createSettingsFieldPreview(
  doc: Document,
  variant: "default" | "error" | "disabled" = "default",
  disabledReason = "",
): HTMLElement {
  const sample = createSessionInactivityCard(doc);
  sample.inert = true;
  sample.setAttribute("aria-hidden", "true");
  const input = sample.querySelector<HTMLInputElement>("input")!;
  input.min = String(MIN_SESSION_INACTIVITY_MINUTES);
  input.max = String(MAX_SESSION_INACTIVITY_MINUTES);
  input.value = String(MIN_SESSION_INACTIVITY_MINUTES);
  sample.querySelector<HTMLElement>("#admin-settings-session-inactivity-help")!.textContent =
    `${boundRangeText(MIN_SESSION_INACTIVITY_MINUTES, MAX_SESSION_INACTIVITY_MINUTES, "minutes")}.`;
  if (variant === "error") {
    // The sentence the live card's own save check gives (admin.ts saveSessionInactivity), for a value below the bound.
    input.value = "0";
    sample.querySelector<HTMLElement>("#admin-session-inactivity-save-status")!.textContent =
      `Session inactivity timeout must be a whole number of minutes, ${boundRangeText(MIN_SESSION_INACTIVITY_MINUTES, MAX_SESSION_INACTIVITY_MINUTES, "minutes")}.`;
  }
  if (variant === "disabled") {
    input.disabled = true;
    sample.querySelector<HTMLButtonElement>("#admin-session-inactivity-save")!.disabled = true;
    // The reason sits with the help line, before the person reaches for the control (principle 11).
    const reason = doc.createElement("p");
    reason.className = "admin-field-help";
    reason.id = "admin-settings-session-inactivity-reason";
    reason.textContent = disabledReason;
    sample.querySelector("#admin-settings-session-inactivity-help")!.after(reason);
    input.setAttribute("aria-describedby", `${input.getAttribute("aria-describedby") ?? ""} ${reason.id}`.trim());
  }
  for (const node of [sample, ...sample.querySelectorAll<HTMLElement>("[id], [data-testid], [for], [aria-describedby]")]) {
    for (const attribute of ["id", "data-testid", "for", "aria-describedby"]) {
      const value = node.getAttribute(attribute);
      if (value !== null) node.setAttribute(attribute, value.split(" ").map(id => `fr-preview-${id}`).join(" "));
    }
  }
  return sample;
}
